import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import info_bulb from "app/images/bulb.svg";

const DemoSpacesDescription = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.content_header_info}>
      <img src={info_bulb} alt="" />
      <div className={styles.main_content}>
        <div className={styles.content_header_content}>
          <p>
            {t(
              "Inside these sample Spaces you'll see real-world interactions between athletes, their parent and a coach over a 6 month period.",
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoSpacesDescription;
